// GoTrue redirects failed email-link verifications back to the site with the
// error in the URL hash (#error=...&error_code=...&error_description=...).
// Left unhandled that reads as "the game signed me out" — this turns it into
// a message the login panel can show. Pure, unit-tested.

export function authErrorMessage(hash: string): string | null {
  if (!hash || hash === '#') return null;
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  if (!params.get('error') && !params.get('error_code')) return null;
  if (params.get('error_code') === 'otp_expired') {
    return (
      'That confirmation link has already been used or expired. ' +
      'Open the newest email in your inbox and use its link — or sign in below to resend it.'
    );
  }
  return params.get('error_description') || 'Sign-in link failed. Please try again.';
}
